import React from 'react';
import { useTranslation } from 'react-i18next';

const Industries = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const industries = [
    {
      title: t('residential'),
      desc: isRTL ? 'فلل فاخرة مع أرضيات وجدران رخامية مخصصة' : 'Luxury villas with custom marble flooring and walls',
      image: 'https://images.pexels.com/photos/33685863/pexels-photo-33685863.jpeg'
    },
    {
      title: t('hotels'),
      desc: isRTL ? 'ردهات فنادق فاخرة وغرف ضيوف راقية' : 'Grand hotel lobbies and elegant guest rooms',
      image: 'https://images.unsplash.com/photo-1663811397133-2d1f5addd9d5'
    },
    {
      title: t('corporate'),
      desc: isRTL ? 'ردهات شركات متطورة ومساحات اجتماعات راقية' : 'Sophisticated corporate lobbies and executive meeting spaces',
      image: 'https://images.unsplash.com/photo-1523292864699-4dcfd824dae2'
    },
    {
      title: t('malls'),
      desc: isRTL ? 'أرضيات تجارية واسعة النطاق وميزات معمارية' : 'Large-scale commercial flooring and architectural features',
      image: 'https://images.unsplash.com/photo-1600421495550-158936f5ecfa'
    },
    {
      title: t('government'),
      desc: isRTL ? 'مبانٍ حكومية هيبة مع تشطيبات حجرية متميزة' : 'Prestigious government buildings with premium stone finishes',
      image: 'https://images.unsplash.com/photo-1735494035457-b6e8f68b5248'
    },
    {
      title: t('religious'),
      desc: isRTL ? 'أماكن عبادة مهيبة بتصاميم حجرية مخصصة' : 'Majestic worship spaces with bespoke stone designs',
      image: 'https://images.unsplash.com/photo-1627382385242-d41b912877eb'
    },
    {
      title: t('hospitality'),
      desc: isRTL ? 'مرافق رعاية صحية ومطاعم فاخرة' : 'Healthcare facilities and fine dining establishments',
      image: 'https://images.pexels.com/photos/7722168/pexels-photo-7722168.jpeg'
    },
  ];

  return (
    <div className="pt-20">
      <section className="section-padding bg-[#F5F5F0]" data-testid="industries-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-4xl text-center mx-auto">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-4">
              {t('industries')}
            </p>
            <h1 className={`text-5xl sm:text-6xl md:text-7xl font-light tracking-tighter leading-none mb-6 ${
              isRTL ? 'font-arabic' : 'font-heading'
            }`} data-testid="industries-title">
              {t('industriesTitle')}
            </h1>
            <p className={`text-xl text-gray-700 ${
              isRTL ? 'font-arabic' : ''
            }`}>
              {t('industriesSubtitle')}
            </p>
          </div>
        </div>
      </section>

      <section className="section-padding bg-white" data-testid="industries-grid">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {industries.map((industry, index) => (
              <div
                key={index}
                className="group overflow-hidden bg-white border border-black/5 hover:border-[#C4A661] transition-all duration-500"
                data-testid={`industry-card-${index}`}
              >
                <div className="overflow-hidden">
                  <img
                    src={industry.image}
                    alt={industry.title}
                    className="w-full h-64 object-cover transform group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className={`text-2xl font-medium mb-3 ${
                    isRTL ? 'font-arabic' : 'font-heading'
                  }`}>
                    {industry.title}
                  </h3>
                  <p className={`text-sm text-gray-600 leading-relaxed ${
                    isRTL ? 'font-arabic' : ''
                  }`}>
                    {industry.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;
